import { createClient } from "@hyper-fetch/core";
import { Socket } from "@hyper-fetch/sockets";

import { getLocale } from "@/paraglide/runtime.js";
import type { ApiErrorTypes } from "@complete-athlete/backend";
import { APP_LANGUAGE_HEADER } from "@complete-athlete/enums";

export const API_BASE_URL = import.meta.env.VITE_API_BASE_URL!;

export const client = createClient<{
  error: ApiErrorTypes;
}>({ url: API_BASE_URL });

// The API answers in the language the page is in: its messages, and exercise names (ADR 0026).
client.onRequest((request) =>
  request.setHeaders({
    ...(request.headers as Record<string, string> | undefined),
    [APP_LANGUAGE_HEADER]: getLocale(),
  }),
);

client.adapter.setRequestDefaults((request) => {
  return {
    options: {
      ...request.options,
      credentials: "include",
    },
  };
});

const wsProtocol = API_BASE_URL.startsWith("https") ? "wss" : "ws";
const wsHost = API_BASE_URL.replace(/^https?:\/\//, "");

export const socket = new Socket({ url: `${wsProtocol}://${wsHost}/ws` });
